import { useTranslation } from 'react-i18next';
import { useModal } from 'Store/modal';

const useBackModalRestriction = () => {
  const { t } = useTranslation('host-attendance');
  const { onOpenModal, onResetModal } = useModal();

  const onBackRestriction = ({ submit }) => {
    onOpenModal({
      width: '239px',
      maxWidth: '339px',
      isOpen: true,
      type: 'confirm',
      title: t('popup_exit.title'),
      contentDescription: t('popup_exit.description'),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('common:sure'),
      secondaryButtonText: t('common:back'),
      onClickPrimaryButton: () => {
        submit();
        onResetModal();
      },
    });
  };

  return { onBackRestriction };
};

export default useBackModalRestriction;
